<template>
  <div class="report-app">
    <transition name="default-opacity-transition" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="sass" scoped>
  div.app__content:not(.login)
    padding-left: 0px
    padding-top: 0px
</style>
